import { CustomConversion } from 'modules/workflows/types';

export const getConversionNamesString = (conversions: CustomConversion[] = []) => {
  if (!conversions) return '';
  const conversionNames = conversions.map((conversion) => `"${conversion.eventName}"`);
  // @ts-ignore NOTE: This is fixed in TS 4.7 with the target of ESNext
  // https://www.typescriptlang.org/play?target=99&ts=4.7.4#code/MYewdgzgLgBApgWwA4AsCGECWAvOATAGU2hgF4Yw4B3GASTCgBsA6I6AMRACcE0oAKAORwwggDQwA3gCgYcmNACejOAC4YgxuADm42fKiKkajaDAArAK5hgUTOD0BfAJTMAZt14CA2oLTjBACNBAF1nAG4gA
  const formatter = new Intl.ListFormat('en', { style: 'long', type: 'conjunction' });
  return formatter.format(conversionNames);
};
